// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"5b9c10b6","323":"c7ac6f8e","337":"6f814c81","802":"672f0d87","915":"e8261985","997":"94fd7b26"}[chunkId] + ".chunk.css";
};